/** Shared superadmin console navigation (desktop tabs + mobile bottom bar). */
export const ADMIN_PRIMARY_MOBILE_KEYS = new Set(["dashboard", "users", "orgs", "pools"]);

export const ADMIN_TABS = [
    { key: "dashboard", to: "/admin/dashboard", label: "Dashboard", shortLabel: "Home" },
    { key: "users", to: "/admin/users", label: "Users", shortLabel: "Users" },
    { key: "orgs", to: "/admin/orgs", label: "Orgs", shortLabel: "Orgs" },
    { key: "pools", to: "/admin/pools", label: "Pools", shortLabel: "Pools" },
    { key: "traffic", to: "/admin/traffic", label: "Traffic", shortLabel: "Traffic" },
    { key: "emails", to: "/admin/emails", label: "Emails", shortLabel: "Emails" },
    { key: "site", to: "/admin/site", label: "Site", shortLabel: "Site" },
    { key: "database", to: "/admin/database", label: "Database", shortLabel: "Data" },
    { key: "audit", to: "/admin/audit", label: "Audit", shortLabel: "Audit" },
    { key: "security", to: "/admin/security", label: "Security", shortLabel: "Security" },
];

export function resolveAdminTab(pathname) {
    const sorted = [...ADMIN_TABS].sort((a, b) => b.to.length - a.to.length);
    return sorted.find((t) => pathname === t.to || pathname.startsWith(`${t.to}/`)) ?? ADMIN_TABS[0];
}

export function adminTabLocked(needs2fa, tabKey) {
    return needs2fa && tabKey !== "security";
}
